(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["soyun-detailed-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('soyun-review-list')) {
    customElements.define('soyun-review-list', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.cards = Array.from(this.querySelectorAll('[data-review]'));
        this.pageSize = Number(this.dataset.pageSize) || 6;
        this.limit = this.pageSize;
        this.more = this.querySelector('[data-review-more]');
        this.moreHandler = () => {
          const next = this.cards[this.limit];
          this.limit += this.pageSize;
          this.update();
          if (next) {
            next.tabIndex = -1;
            next.focus({preventScroll:true});
          }
        };
        this.more.addEventListener('click', this.moreHandler);
        this.editorHandler = event => {
          const card = event.target.closest('[data-review]');
          if (!card || !this.contains(card)) return;
          this.limit = Math.max(this.limit, this.cards.indexOf(card) + 1);
          this.update();
        };
        this.addEventListener('shopify:block:select', this.editorHandler);
        this.update();
      }
      disconnectedCallback() {
        this.more?.removeEventListener('click', this.moreHandler);
        this.removeEventListener('shopify:block:select', this.editorHandler);
        this.ready = false;
      }
      update() {
        this.cards.forEach((card,index) => { card.hidden = index >= this.limit; });
        this.more.hidden = this.limit >= this.cards.length;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soyun-rituel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('soyun-ritual')) {
    customElements.define('soyun-ritual', class extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.mount());
      }

      mount() {
        if (this.controller) return;
        this.track = this.querySelector('[data-sy-track]');
        this.cards = Array.from(this.querySelectorAll('[data-sy-card]'));
        this.tabs = Array.from(this.querySelectorAll('[data-sy-tab]'));
        this.status = this.querySelector('[data-sy-status]');
        if (!this.track || !this.cards.length) return;
        this.index = 0;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.mobile = matchMedia('(max-width: 749px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

        this.addEventListener('click', event => {
          const tab = event.target.closest('[data-sy-tab]');
          if (tab && this.contains(tab)) {
            this.goTo(Number(tab.dataset.syTab));
            return;
          }
          const arrow = event.target.closest('[data-sy-direction]');
          if (arrow && this.contains(arrow) && !arrow.disabled) {
            const from = this.cards.indexOf(arrow.closest('[data-sy-card]'));
            this.goTo(from + Number(arrow.dataset.syDirection), true);
          }
        }, options);

        this.addEventListener('keydown', event => {
          const tab = event.target.closest('[data-sy-tab]');
          if (!tab || !this.mobile.matches) return;
          let next = Number(tab.dataset.syTab);
          if (event.key === 'ArrowRight') next += 1;
          else if (event.key === 'ArrowLeft') next -= 1;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.cards.length - 1;
          else return;
          event.preventDefault();
          next = Math.max(0, Math.min(next, this.cards.length - 1));
          this.goTo(next);
          this.tabs[next]?.focus({ preventScroll: true });
        }, options);

        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.syncFromScroll());
        }, { ...options, passive: true });

        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('[data-sy-card]');
          const index = this.cards.indexOf(card);
          if (index >= 0) this.goTo(index, false, false);
        }, options);

        this.mobile.addEventListener('change', () => this.realign(), options);
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => this.realign());
        });
        this.resizeObserver.observe(this.track);
        this.classList.add('is-ready');
        this.setActive(0, false);
      }

      positionFor(index) {
        const padding = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
        return this.track.scrollLeft + this.cards[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left - padding;
      }

      goTo(index, moveFocus = false, smooth = true) {
        const next = Math.max(0, Math.min(index, this.cards.length - 1));
        this.setActive(next, true);
        if (this.mobile.matches) {
          this.track.scrollTo({
            left: this.positionFor(next),
            behavior: smooth && !this.reducedMotion.matches ? 'smooth' : 'instant'
          });
        }
        if (moveFocus) this.cards[next].focus({ preventScroll: true });
      }

      syncFromScroll() {
        if (!this.mobile.matches) return;
        let nearest = 0;
        let distance = Infinity;
        this.cards.forEach((card, index) => {
          const difference = Math.abs(this.positionFor(index) - this.track.scrollLeft);
          if (difference < distance) {
            distance = difference;
            nearest = index;
          }
        });
        if (nearest !== this.index) this.setActive(nearest, true);
      }

      setActive(index, announce) {
        this.index = index;
        this.tabs.forEach((tab, i) => tab.setAttribute('aria-pressed', String(i === index)));
        if (announce && this.status) {
          const title = this.cards[index].querySelector('h3')?.textContent || '';
          this.status.textContent = `${index + 1} / ${this.cards.length}: ${title}`;
        }
      }

      realign() {
        if (!this.controller) return;
        this.track.scrollTo({ left: this.mobile.matches ? this.positionFor(this.index) : 0, behavior: 'instant' });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        cancelAnimationFrame(this.scrollFrame);
        cancelAnimationFrame(this.resizeFrame);
        this.resizeObserver?.disconnect();
        this.controller?.abort();
        this.controller = null;
        this.classList.remove('is-ready');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
